<template>
  <div class="form-group kt-form kt-form--label-right mb-1 text-left">
    <div class="row mb-0">
      <div class="col-lg-6 col-12" v-if="brands">
        <BaseSelect
          label="Brand"
          :options="brands"
          :isMandatory="true"
          v-model="$v.brand.$model"
          @blur="$v.brand.$touch()"
          :validator="$v.brand" />
      </div>
      <div class="col-lg-6 col-12" v-if="themes">
        <BaseSelect
          label="Theme"
          :options="themes"
          :disabled="isSearching"
          :isMandatory="false"
          v-model="$v.theme.$model"
          @blur="$v.theme.$touch()"
          :validator="$v.theme" />
      </div>
      <div class="col-lg-6 col-12">
        <BaseInputForm
          type="text"
          label="Keyword"
          placeholder="Ex. Munich to Vienna"
          autofocus
          :isMandatory="true"
          @keyup.enter="onSearch"
          v-model="$v.keyword.$model"
          @blur="$v.keyword.$touch()"
          :validator="$v.keyword" />
      </div>
    </div>
  </div>

</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import debounce from 'lodash.debounce'

export default {
  name: 'TabItinerarySearchForm',
  data () {
    return {
      brand: '',
      theme: '',
      keyword: ''
    }
  },
  validations: {
    brand: { required },
    theme: {},
    keyword: { required, minLength: minLength(3) }
  },
  props: {
    brands: {
      type: Array,
      require: true
    },
    themes: {
      type: Array,
      require: true
    },
    isSearching: {
      type: Boolean,
      required: false
    }
  },
  created () {
    this.debouncedSearch = debounce(this.onSearch, 500)
  },
  watch: {
    brand (newValue, oldValue) {
      this.watchHandler(newValue, oldValue)
    },
    theme (newValue, oldValue) {
      this.watchHandler(newValue, oldValue)
    },
    keyword (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.debouncedSearch()
      }
    }
  },
  methods: {
    watchHandler (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onSearch()
      }
    },
    onSearch () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const params = {
          format: Number(this.format),
          brand: Number(this.brand),
          theme: Number(this.theme),
          query: this.keyword,
          limit: 20,
          offset: 0
        }
        this.$emit('onSearch', params)
      }
    },
    onReset () {
      this.$emit('onReset')
    }
  }
}
</script>
